<template>
  <div
    class="balloon"
    :class="{
      'incoming-message': data.author_type === 'CCU',
      'outcoming-message': data.author_type === 'me',
    }"
  >
    <div class="system" v-if="data.isSystemMessage">
      <div class="time">{{ data.time }}</div>
      <div class="text">{{ data.text }}</div>
    </div>
    <div class="header" v-if="!data.isSystemMessage">
      <span
        v-if="conversationView.isShowIconInChatBalloon"
        class="time icon-span"
        style="padding-right:5px; padding-left:5px; "
      >
        <img
          v-if="data.author_type === 'me'"
          class="balloon-icon"
          :src="widgetData.config.customerIconLink"
        />
        <img
          v-if="data.author_type === 'CCU'"
          class="balloon-icon"
          :src="widgetData.config.agentIconLink"
        />
      </span>
      <span
        class="time name-span"
        v-if="conversationView.isShowNameInChatBalloon"
        >{{ nameToShow }}</span
      >
      <span
        class="time"
        style="padding-right:5px; padding-left:5px; "
        :style="{ paddingTop: timePadding + 'px' }"
        >{{ data.time }}</span
      >
    </div>
    <div
      class="user"
      :class="{
        'my-balloon': data.author_type === 'me',
        'agent-balloon': data.author_type === 'CCU',
      }"
      v-if="!data.isSystemMessage"
    >
      <div class="text" >
        <span style="white-space: pre-wrap;" v-if="data.text" v-html="getLinkifyText(data.text,false)"></span>
        <span style="white-space: pre-wrap;"
          v-if="data.URL_Pushed"
          v-html="getLinkifyText(data.URL_Pushed,true)"
        ></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import linkifyStr from "linkify-string";

export default {
  name: "Balloon",
  props: ["data"],
  data() {
    return {
      messageDirection: "",
      postfixes: ["pdf","doc","com","png","jpg"],
    };
  },
  computed: {
    timePadding() {
      return this.data.author_type === "CCU" ? 10 : 3;
    },
    ...mapGetters(["appData", "widgetData", "conversationView"]),
    nameToShow() {
      if (this.data.author_type === "CCU") {
        return this.data.author;
      }
      return this.appData.JoinChatData.Calling_User_FirstName;
    },
  },
  created(){
    if(this.widgetData.config.messageLinkPostfixes){
      this.postfixes = this.widgetData.config.messageLinkPostfixes;
    }
  },
  methods: {
    getLinkifyText(txt,isUrl) {
      let endcoedTxt = "";
      let options = {
        /* � */
        target:"_blank"
      };
      //  if(isUrl){
      //   //  endcoedTxt = txt.replace("↵","</br>")
      //    endcoedTxt = encodeURI(txt);
      //  }
      //  else{
        endcoedTxt = this.manipulateStr(txt);
      //  }
    return linkifyStr(endcoedTxt, options);
    // return endcoedTxt;
    },

    //find the postfix inside the substring
    getPostfixIndex(str){
      var postfixIndex = -1;
      for (let p of this.postfixes){
            var modifiedIndexOf = -1;
            var modifiedPostfix = "."+ p.toLowerCase();
            var i = str.toLowerCase().indexOf(modifiedPostfix);
            if( i > -1 && str[i+modifiedPostfix.length] !== "/" && str[i+modifiedPostfix.length] !== "?" ){
              modifiedIndexOf = i;
            }
            if(modifiedIndexOf > -1  && (postfixIndex == -1 || modifiedIndexOf < postfixIndex)){
              postfixIndex = modifiedIndexOf;
            }
      }
      return postfixIndex;
    },

    regexIndexOf(string, regex, startpos) {
      var indexOf = string.substring(startpos || 0).search(regex);
      return (indexOf >= 0) ? (indexOf + (startpos || 0)) : indexOf;
    },

    manipulateStr(str){
       var currentStr = str;
       var currentSubstring = "";
       var postfixIndex = -1;
       var finalStr = "";
        while(currentStr !== ""){
          if(this.regexIndexOf(currentStr,"(http|https)://") == -1){
              finalStr += currentStr.slice(0,9999999999999);
              currentStr = currentStr.slice(9999999999999,9999999999999);
          }
          else{
               finalStr += currentStr.slice(0,this.regexIndexOf(currentStr,"(http|https)://"));
               currentStr = currentStr.slice(this.regexIndexOf(currentStr,"(http|https)://"),99999999);
              //set the substring until next prefix 
              postfixIndex = this.getPostfixIndex(currentStr)
              currentSubstring  = currentStr.substring(this.regexIndexOf(currentStr,"(http|https)://") , postfixIndex+3);
              if(postfixIndex > -1){
                finalStr += encodeURI(currentSubstring);
              }
              else{
                finalStr += currentSubstring;
              }
              currentStr = currentStr.slice(postfixIndex+3,9999999999999);
             
          }
        }
       return finalStr
    }



  },
};
</script>

<style scoped>
.balloon {
  flex-direction: column;
  width: 100%;
  word-break: break-word;
}
.balloon > .user {
  border-radius: 25px;
  box-shadow: 0 0 18px 6px #a3a3a340;
  border: none;
  padding: 10px 25px;
  margin: 5px 0px;
  height: auto;
  position: relative;
}

.balloon > .user.my-balloon {
  background-color: #ffffff;
  color: rgba(0, 0, 0, 0.76);
  border-bottom-right-radius: 0;
  align-self: flex-end;
}

.balloon > .user.agent-balloon {
  background-color: #4fc1ec;
  color: #ffffff;
  border-bottom-left-radius: 0;
  align-self: flex-start;
}
.balloon-system {
  height: auto;
  width: 305px;
  margin: 5px;
  padding: 5px;
  color: #6d6d6d;
  font-size: smaller;
}
.outcoming-message {
  /*float: left;*/
  display: flex;
  justify-content: flex-end;
}
.incoming-message {
  /*float: right;*/
  display: flex;
}

.balloon .text {
  word-wrap: break-word;
  text-align: center;
}
.balloon.outcoming-message .time {
  float: right;
}

.balloon .time {
  padding-top: 1.5px;
}

.balloon .system .text,
.balloon .time {
  padding-top: 1.5px;
  color: rgba(0, 0, 0, 0.52);
  font-size: 10pt;
  text-align: center;
}
.balloon .system {
  width: 98%;
}
</style>
